
// services/booking.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Booking } from '../../objects/booking';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BookingService {
  private apiUrl = environment.apiUrl + 'Bookings';

  constructor(private http: HttpClient) {}

  createBooking(booking: Partial<Booking>): Observable<Booking> {
    return this.http.post<Booking>(this.apiUrl, booking);
  }

  getBookings(userId: string, role: 'customer' | 'provider'): Observable<Booking[]> {
    return this.http.get<Booking[]>(`${this.apiUrl}/${role}/${userId}`);
  }

  updateBookingStatus(bookingId: string, status: string): Observable<Booking> {
    return this.http.patch<Booking>(`${this.apiUrl}/${bookingId}`, { status });
  }
}